@if (anticipatedTime) {
  <div class="default-color" [ngStyle]="{color: countdownColor}">
    <i class="pi pi-clock font-normal mr-2"></i>
    <span>{{ anticipatedTime + ' remaining'}}</span>
  </div>
}
